import script from "./ControllerDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControllerDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ControllerDetail.vue?vue&type=style&index=0&id=5d66f422&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d66f422"]])

export default __exports__